import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/suppliers')({
  beforeLoad: ({ context, params }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('suppliers:list')) {
      throw redirect({ params: { territoryId: params.territoryId }, to: '/settings/territories/$territoryId' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/suppliers/pages/territory-suppliers-page').then((m) => ({
      default: m.TerritorySuppliersPage,
    })),
  ),
  staticData: { titleKey: 'suppliers' },
});
